import { useAuth } from '../context/AuthContext';

/** True when the caller holds {@code key} in the selected institution (SystemAdmin: always). */
export function usePermission(key: string): boolean {
    const { hasPermission } = useAuth();
    return hasPermission(key);
}

export function useIsAdmin(): boolean {
    const { isAdmin, isSystemAdmin } = useAuth();
    return isAdmin || isSystemAdmin;
}
